import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

interface JustificationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  selectedDiscrepancy: {
    expected_amount: number;
    counted_amount: number;
  } | null;
  selectedAmount: 'expected' | 'counted';
  onAmountChange: (value: 'expected' | 'counted') => void;
  onConfirm: () => void;
}

export const JustificationDialog = ({
  isOpen,
  onOpenChange,
  selectedDiscrepancy,
  selectedAmount,
  onAmountChange,
  onConfirm,
}: JustificationDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Choisir le montant à valider</DialogTitle>
          <DialogDescription>
            Sélectionnez le montant qui sera utilisé comme chiffre d'affaires pour cette période
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-6">
          <RadioGroup value={selectedAmount} onValueChange={onAmountChange}>
            <div className="flex items-center space-x-2 mb-4">
              <RadioGroupItem value="expected" id="expected" />
              <Label htmlFor="expected">
                Montant attendu ({selectedDiscrepancy?.expected_amount.toLocaleString()} FCFA)
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="counted" id="counted" />
              <Label htmlFor="counted">
                Montant compté ({selectedDiscrepancy?.counted_amount.toLocaleString()} FCFA)
              </Label>
            </div>
          </RadioGroup>
        </div>

        <div className="flex justify-end gap-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button onClick={onConfirm}>
            Confirmer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};